import React, { useContext } from "react";

export const SettingsCheckerContext = React.createContext();

export const useCheckIfInSettings = () => {
  const result = useContext(SettingsCheckerContext);
  return result;
};
